import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonSkeletonText,
} from '@ionic/angular';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { PayrollUnitName } from '@wilson/interfaces';
import { MinutesToHoursMinutesPipe } from '@wilson/pipes';
import { map } from 'rxjs';
import { FitTextDirective } from './fit-text.directive';

@Component({
  selector: 'wilson-worktime-metrics-card',
  standalone: true,
  imports: [
    CommonModule,
    IonCard,
    IonCardContent,
    IonSkeletonText,
    TranslatePipe,
    FitTextDirective,
    IonCardHeader,
    MinutesToHoursMinutesPipe,
  ],
  templateUrl: './worktime-metrics-card.component.html',
  styleUrl: './worktime-metrics-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorktimeMetricsCardComponent {
  private readonly translateService = inject(TranslateService);

  readonly header = input.required<string>();
  readonly values = input.required<(number | null)[]>();
  readonly separator = input<string>('/');
  readonly unit = input.required<PayrollUnitName | ''>();
  readonly loading = input<boolean>(false);

  protected PayrollUnitName = PayrollUnitName;

  protected readonly currentLang = toSignal(
    this.translateService.onLangChange.pipe(map((e) => e.lang)),
    { initialValue: this.translateService.getCurrentLang() ?? undefined },
  );
}
